import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/hr/employees/$employeeId/edit',
}).lazy(() => import('./$employeeId.edit.lazy').then((d) => d.Route))
